<template>
  <div id="container">
    <div id="title">
      <h2>{{ $t('generic.contentType') }}</h2>
      <h1>
        {{ contentTypeName }}
      </h1>
    </div>

    <csv-reader id="csv-reader" @headers="getHeaders" />

    <content-type-mapping-table
      id="content-type-mapping-table"
      :headers="headers || []"
      :content-type-id="contentTypeId"
      :project-id="projectId"
      :supplier-id="supplierId"
      :mode="mode"
    />
  </div>
</template>

<script src="./ContentTypeConfiguration.script.ts"></script>
<style scoped lang="scss" src="./ContentTypeConfiguration.styles.scss"></style>
